export enum MeterType {
    INTELIGENTE = "INTELIGENTE",
    ELECTROMECANICO = "ELECTROMECANICO",
    ESTATICO = "ESTATICO"
}
